import React, { useEffect, useMemo } from 'react';
import { StyledCincopaContainer } from '@/components/gallery/components';

interface CincopaDefaultGalleryProps {
  objectId?: string;
  fid?: string;
}

const CincopaDefaultGallery: React.FC<CincopaDefaultGalleryProps> = ({
  fid: fidProp,
}) => {
  const objectId = 'moments_full_gallery';
  const fid = fidProp?.trim()

  const hasValidIds: boolean = useMemo(
    () => Boolean(objectId && fid),
    [objectId, fid],
  );

  useEffect(() => {
    if (!hasValidIds) return;

    const win = window as any;
    win.cincopa = win.cincopa || {};
    win._cpmp = [];

    const cpo = {
      _object: objectId,
      _fid: fid,
    };
    win._cpmp.push(cpo);

    const scriptId = 'cincopa-libasync';
    const existingScript = document.getElementById(scriptId);
    if (existingScript) {
      existingScript.parentElement?.removeChild(existingScript);
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://rtcdn.cincopa.com/libasync.js';
    document.head.appendChild(script);

    return () => {
      win._cpmp = [];
    };
  }, [hasValidIds, objectId, fid]);

  if (!hasValidIds) {
    return (
      <div className="cincopa-container cincopa-placeholder">
        <p>No photos</p>
      </div>
    );
  }

  return (
    <StyledCincopaContainer>
      <div id={objectId} />
    </StyledCincopaContainer>
  );
};

export default CincopaDefaultGallery;
